import { gql } from "@apollo/client";

export default gql`
  query getComplianceProgramTimeline($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      timeline {
        date
        kind
        label
        note
        step
        notificationType
        channels
        recipientCount
        skippedCount
        recipientsKnown
        isPast
        skipped {
          reason
          user {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;
